import * as React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { 
  CloudDone as CloudDoneIcon,
  DriveFolderUpload as DriveFolderUploadIcon,
  DocumentScanner as DocumentScannerIcon,
  Details as DetailsIcon 
} from "@mui/icons-material";
import UploadForm from "./UploadForm";
import { ContextData } from "../../../../../../../context/Context";
import { Getrequest } from "../../../../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import Loader from "../../../../../../../routes/Loader";
import GetPersonData from "../../../../../../../context/GetPersonData";

export default function UploadSection() {


  const { UserTokens, accesstoken ,ChangeLoanForm,setChangeLoanForm} = React.useContext(ContextData);
  const [dataSet, setDataSet] = React.useState(null);
  const [personData, setPersonData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [docStatus, setDocStatus] = React.useState(null);
  const [applicationType, setApplicationType] = React.useState("");
  const [filteredDocList, setFilteredDocList] = React.useState([]);

  // Fetch person data
  React.useEffect(() => {

    const fetchPersonData = async () => {


      try {
        setIsLoading(true);
        const data = await GetPersonData(UserTokens, accesstoken);

        const loanData = await Getrequest(`/auth/get_loan_data/${UserTokens}`,accesstoken)

        if(loanData) setChangeLoanForm(loanData?.loanrequest[0]?.loan_category)

        if (data) setPersonData(data);
        
      } catch (error) {
        toast.error('Failed to fetch person data');
      } finally {
        setIsLoading(false);
      } 


    }


    if (UserTokens && accesstoken) {
      fetchPersonData();
    }


  }, [UserTokens, accesstoken]);

  // Fetch application type and documents
  React.useEffect(() => {

    const fetchApplicationData = async () => {

      try {

        setIsLoading(true);
        const response = await Getrequest(`/auth/get_app_type/${UserTokens}`,accesstoken);
        const fetchedType = String(response?.[0]?.application_type ?? '').trim();
        
        if (fetchedType) {
          setApplicationType(fetchedType);
          const docsResponse = await Getrequest(`/auth/get_upload_doc_applicant_section/${fetchedType}`, accesstoken);
          setDataSet(docsResponse);
        }
      } catch (error) {
        toast.error('Failed to fetch application data');
      } finally {
        setIsLoading(false);
      }

    }

    if (accesstoken && UserTokens) {
      fetchApplicationData();
    }
  }, [accesstoken, UserTokens]);

  

  // Filter documents based on person data
  React.useEffect(() => {

    if (personData && dataSet) {

      const filtered = dataSet.filter(item => {

      const isMatchingType = (personData.edu_data[0].applying_for_type.toLowerCase() === item.documentType || item.documentType === "both"  );
      const isCategoryType = (ChangeLoanForm === item.loan_category)

        return (
          (personData.bio_data[0].resdential_type === item.resdentialType && isMatchingType) || 
          (item.resdentialType === "both" && isMatchingType && isCategoryType) 
        ); 
      });
       
      setFilteredDocList(filtered);
    }
     
  }, [personData, dataSet]);

  const DocumentCard = ({ item }) => (

    <button className="p-6 bg-white text-blue-900 shadow-lg rounded-lg hover:scale-105 transition-transform duration-300 text-center relative">
      <div className="mb-2">
          
        <DriveFolderUploadIcon sx={{ fontSize: "5em" }} />
      </div>
      <p className="text-xl font-bold capitalize">{item.document_type_name}</p>
      {/* <Typography variant="body2" sx={{ color: "gray" }}>
        Residential Type: {item.resdentialType} {item.resdential_type}
      </Typography> */}
      <Box display="flex" justifyContent="center" mt={2} gap={1}>
        <CloudDoneIcon sx={{ color: "green" }} />
        <DocumentScannerIcon sx={{ color: "blue" }} />
        <DetailsIcon sx={{ color: "purple" }} />
      </Box>
      <div className="flex w-full justify-center items-center">
        <UploadForm data={item} setDocStatus={setDocStatus} />
      </div>
    </button>
  );

  if(filteredDocList < 0){
 
     return (
    <div className="w-full">
      <Loader OpenLoader={isLoading} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10 w-full max-w-4xl mx-auto font-mono">
         <p>Fetching....</p>
      </div>
    </div>
  );

  }

  return (
    <div className="w-full">
      <Loader OpenLoader={isLoading} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10 w-full max-w-4xl mx-auto font-mono">
        {filteredDocList.map((item, index) => (
          <DocumentCard key={index} item={item} />
        ))}
      </div>
      
    </div>
  );
}
